module.exports = __webpack_public_path__ + "files/3a10ceb621f350d146eb0d7f499be098.png";